import React from 'react';
// import NotifSvg from '../../../../../../../svgs/NotifSvg';

const Notifications = () => <div className="notifIconParent"> {/* <NotifSvg /> */}</div>;

export default Notifications;
